import React from 'react';

import style from './index.module.scss';

import clsx from 'clsx';
import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { Stack } from 'components/stack';
import { useTranslate } from 'hooks/use-translate';

interface Classes {
  root: string;
}

interface Props {
  className?: string;
  classes?: Partial<Classes>;
}

export const NotFound: React.FC<React.PropsWithChildren<Props>> = ({ className, classes }) => {
  const { t } = useTranslate();
  const navigate = useNavigate();

  return (
    <div className={clsx(style.root, classes?.root, className)}>
      <Stack
        spacing={2}
        direction={'column'}
        sx={{
          alignItems: 'center',
        }}
      >
        <Typography variant={'h1'}>{t('not-found')}</Typography>
        <Button color={'primary'} variant={'outlined'} onClick={() => navigate(-1)}>
          {t('go-back')}
        </Button>
      </Stack>
    </div>
  );
};
